/* eslint-disable react/display-name */
import * as React from 'react'
import classnames from 'classnames'
import {RefProp, InputType} from '../types'
import styles from './styles.module.css'

export interface Props extends InputType<string> {
  /** Sets placeholder property on underlying `input` element*/
  placeholder?: string
  /** an optional string of additional classes to add to the parent element. */
  displayClasses?: string
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  search?: boolean
  password?: boolean
  onBlur?: () => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void
}

/** This component used by itself is not accessible.
 * Please use the LabeledTextInput.
 * It has an optionally visible label. */
const TextInput: React.FC<RefProp<HTMLInputElement, Props>> = ({
  id,
  name,
  onChange,
  value = '',
  elementRef,
  placeholder = '',
  displayClasses,
  onKeyPress,
  search = false,
  password = false,
  error = false,
  disabled,
  onBlur,
  onKeyDown,
  onPaste,
  maxLength,
  dataSeleniumTarget,
  ...rest
}) => {
  const updateValue: React.ChangeEventHandler<HTMLInputElement> = (ev) => {
    onChange(ev.target.value)
  }
  const classes = classnames(styles.input, displayClasses, {
    [`${styles.search}`]: search,
    [`${styles.error}`]: error,
  })

  let inputType = 'text'
  if (search) inputType = 'search'
  if (password) inputType = 'password'

  return (
    <input
      id={id}
      name={name}
      className={classes}
      type={inputType}
      placeholder={placeholder}
      value={value}
      onChange={updateValue}
      ref={elementRef}
      disabled={disabled}
      onKeyPress={onKeyPress}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      maxLength={maxLength}
      data-selenium-target={dataSeleniumTarget}
      {...rest}
    />
  )
}

export default React.forwardRef<HTMLInputElement, Props>((props, ref) => (
  <TextInput elementRef={ref} {...props} />
))
